import React from 'react';

function RecipeError(){
  return(
    <section id="error">
      <h1 style={{color: "red"}}> This page does not exist.</h1>
    </section>
  )
}

export default RecipeError;